const customerApi = process.env.VUE_APP_URL_CUSTOMER_API;
const authApi = process.env.VUE_APP_URL_AUTHENTICATION_API;
const productApi = process.env.VUE_APP_URL_PRODUCT_API;
const InvestmentPortfolioApi = process.env.VUE_APP_URL_INVESTMENTPORTFOLIO_API;

export default class Endpoint {
  public login = `${authApi}/connect/token`;
  public authLogAll = `${authApi}/api/info/log-all`;
  public generatePassword = `${authApi}/api/authentication/changepassword`;
  public createUser = `${authApi}/api/customer`;
  public createListUser = `${authApi}/api/customer/create-list`;

  public mirrorAccount =  `${authApi}/api/customer/mirror-access`; 
  
  public setRole = `${authApi}/api/customer/setrole`;
  public getUserByEmail = `${authApi}/api/user/email/`;
  public getAllUsers = `${authApi}/api/user/all`;

  
  public customerLogAll = `${customerApi}/api/info/log-all`;
  public groupCustomers = `${customerApi}/api/customer/family-member`;
  public customers = `${customerApi}/api/customer`;
  public customerBydId = `${customerApi}/api/customer/userid`;
  public pagedCustomers = `${customerApi}/api/customer/filter-paged`;
  public selectItemsCustomers = `${customerApi}/api/customer/select-items`;
  public customersFilter = `${customerApi}/api/customer/filter`;
  public acceptCustomer = `${customerApi}/api/customer/accept`;
  public acceptListCustomer = `${customerApi}/api/customer/accept-list`;
  public refuseCustomer = `${customerApi}/api/customer/refuse`;
  public undoRefuse = `${customerApi}/api/customer/undo-refuse`;
  public notifications = `${customerApi}/api/notification`;

  public companies = `${customerApi}/api/company`;

  public lesteUser = `${customerApi}/api/lesteuser`;
  public lesteUserSetIsManager = `${customerApi}/api/lesteuser/set-lestemanager`;

  public createInterest = `${customerApi}/api/signup`;

  public importInterest = `${customerApi}/api/signup/import-interest`;
  public importCip = `${customerApi}/api/formfield/import-cip`;

  public notificationsTypes = `${customerApi}/api/notification/all-types`;
  public deleteNotifications = `${customerApi}/api/notification/`;

  public sendSubdocumentContract = `${customerApi}/api/formfield/send-to-fill`;
  public uploadToAzure = `${customerApi}/api/document/upload-to-azure`;

  public productLogAll = `${productApi}/api/info/log-all`;
  public investments = `${productApi}/api/product/myinterests`;
  public editOrCreateInvestment = `${productApi}/api/product/interest/save`;

  public products = `${productApi}/api/product?onlyPublishedProducts=false&&noFilterByDomicile=true`;
  public productsOnlyPublished = `${productApi}/api/product?onlyPublishedProducts=true&&noFilterByDomicile=true`;
  public product = `${productApi}/api/product/detail`;
  public saveProduct = `${productApi}/api/product/save`;
  public productFile = `${productApi}/api/product/file`;
  public productDelete = `${productApi}/api/product/delete`;
  public productSelectItems = `${productApi}/api/product/select-items`;

  public listSubDocumentsFiles = `${productApi}/api/product/subdocuments-files`;
  public uploadSubDocumentsFile = `${productApi}/api/product/subdocuments-upload`;
  public deleteSubDocumentsFile = `${productApi}/api/product/subdocuments-file`;

  public productBackground = `${productApi}/api/product/background`;
  public donwloadFile = `${productApi}/api/product/donwload`;
  public productAreas = `${productApi}/api/product/areas?skip=0&take=100`;

  public productFund = `${productApi}/api/fund/selectItems`;
  public productFundById = `${productApi}/api/fund/?fundId=`;

  public productCreate = `${productApi}/api/product`;
  public productClearCache = `${productApi}/api/info/clear-cache`;
  public productGetCache = `${productApi}/api/info/jobinfo`;
  public saveProductsExcelFile = `${productApi}/api/product/excel`;

  public scheduling = `${customerApi}/api/Scheduler/scheduled`;
  public schedule = `${customerApi}/api/scheduler`;
  public skipKyc = `${customerApi}/api/veriff/skip-kyc`;
  public forgetPassword = `${customerApi}/api/customer/forget-password`;
  public scheduleAction = `${customerApi}/api/scheduler/status`;
  public customerClearCache = `${customerApi}/api/info/clear-cache`;
  public customerGetCache = `${customerApi}/api/info/jobinfo`;

  public customerHasAccount = `${InvestmentPortfolioApi}/api/userinfo/has-account?userId=`;
  public investmentLogAll = `${InvestmentPortfolioApi}/api/info/log-all`;
  public customerUsersByFund = `${InvestmentPortfolioApi}/api/userinfo/users-by-fund?fundId=`;

  public exportProductsAsExcel = `${productApi}/api/product/exportAsExcel`;

  public account = `${InvestmentPortfolioApi}/api/userinfo`;
  public accountsGetAll = `${InvestmentPortfolioApi}/api/userinfo/all`;
  public accountsGetByUser = `${InvestmentPortfolioApi}/api/userinfo/byuserid`;
  public accountsClone = `${InvestmentPortfolioApi}/api/userinfo/clone`;
  public accountsClearCache = `${InvestmentPortfolioApi}/api/info/clear-cache`;
  public accountsGetCache = `${InvestmentPortfolioApi}/api/info/jobinfo`;

  public news = `${productApi}/api/news`;
  public newsPaged = `${productApi}/api/news/paged`;
  public newspublished = `${productApi}/api/news/published`;

}
